import Activity from '@/models/Activity';

export default class TakeTask extends Activity {
  constructor({ reference, departurePath, returnPath }) {
    super({ reference });

    this.reference.task = this.reference.team.getPendingTask();
    this.reference.task.setAssignee(this.reference);
    this.reference.skills.moving.setPath(departurePath);

    this.onReturnPath = false;
    this.returnPath = returnPath;
  }

  execute() {
    if (this.onReturnPath) {
      this.finish();
      return;
    }
    this.reference.skills.moving.setPath(this.returnPath);
    this.onReturnPath = true;
  }

  finish() {
    this.reference.setOnSeat();
    this.reference.processTask();
  }
}
